// extracted by mini-css-extract-plugin
module.exports = {"container":"_4e5f713ae4--container--follB","link":"_4e5f713ae4--link--JGhh4"};